import { connect } from "react-redux";
import { bindActionCreators,Dispatch } from "redux";
import { isEditActiveSelector } from "../../../reducers/editReducer";
import * as React from "react";
import EditParameter from "../../Editing/EditParameter";
import { Dimmer } from "semantic-ui-react";
import Table from "../../../components/Table/Table";
import { setParameterExtraProperties, filterUserGroupParameters } from "../../../utils/pdApiUtils";
import { EditActions, editActions } from "../../../actions/editActions";
import { pdApiActions } from "../../../actions/pdApiActions";
import { escalatorVersionFilter } from "../../../utils/utils";
import { mainActions, MainActions } from "../../../actions/mainActions";
import { Filter } from "../../../components/Table/Migration/LegacyTypes";
import _ from "lodash";

/**
 * All the following props are passed from parent component
 */
type StateProps = {
  pdApi: State.PdApi;
  columns: State.ColumnMap;
  mainState: State.Main;
  editedObjectId: number | undefined;
  isEditActive: boolean;
  subMenuRoute: State.EscalatorSubmenu;
  columnFilters: Filter[];
  filterOptions: State.FilterOptions;
  setColumnFilters: (subMenuRoute: State.EscalatorSubmenu, columnFilter: Filter[]) => void;
}

type DispatchProps = {
  pdApiActions: typeof pdApiActions;
  editActions: typeof editActions;
  mainActions: typeof mainActions;
};

type OwnProps = {
  toggleModal: () => void;
  isLoadingEscalatorParameters: boolean;
};

export type EscalatorParametersTableProps = StateProps & DispatchProps & OwnProps;

type EscalatorParametersTableState = {
  isModalOpen: boolean;
};

export class EscalatorParametersTable extends React.Component<
  EscalatorParametersTableProps,
  EscalatorParametersTableState
> {
  state = {
    isModalOpen: false
  };

  componentDidMount(): void {
    // make throttle function
    this.handleFilterChangeDebounced = _.debounce(this.handleFilterChangeDebounced, 500);
  }

  private handleFilterChangeDebounced = (changedFilters: Filter[]) => {
    this.props.setColumnFilters(this.props.subMenuRoute, changedFilters);
  };

  componentWillUnmount(): void {
    this.props.mainActions.setLastEditedObjectId(undefined);
  }

  render(): JSX.Element {
    const {
      columns,
      pdApi,
      mainState,
      isEditActive,
      toggleModal,
      filterOptions,
      isLoadingEscalatorParameters
    } = this.props;
    const { escalatorParameters } = pdApi;
    const { editSize, pageSize, isShortenTextEnabled } = mainState;
    let parameterRows: Api.EscalatorParameter[] = [];
    let filteredRows: Api.EscalatorParameter[] = [];
    let selectedColumns: State.Column[] = [];

    parameterRows = escalatorParameters;
    parameterRows = parameterRows?.map(row => setParameterExtraProperties(row, pdApi)) as Api.EscalatorParameter[];
    filteredRows = escalatorVersionFilter(parameterRows, filterOptions.selectedEscalatorVersion);

    if (filteredRows.length > 0) {
      const filteredUserGroup =
        filterOptions.selectedEscalatorUserGroup === -1
          ? filteredRows
          : filterUserGroupParameters(filteredRows, filterOptions.selectedEscalatorUserGroup);
    
      filteredRows = filteredUserGroup as Api.EscalatorParameter[];
    }
    
    selectedColumns = columns["Escalator Parameters"];

    const startingPage = mainState.lastEditedObjectId
      ? (filteredRows.findIndex(parameter => parameter.id === mainState.lastEditedObjectId) / // tslint:disable-line: no-bitwise
          mainState.pageSize) >>
        0
      : 0;

    // Add submenu specific columns and rows
    return (
      <div className="flex-1">
        <div className="flex-1">
          <Table
            startingPage={startingPage}
            rows={filteredRows}
            loading={isLoadingEscalatorParameters}
            loadingText="Fetching Escalator parameters..."
            columns={selectedColumns}
            isHidingTextActive={isShortenTextEnabled}
            handleRowSelection={this.props.editActions.select}
            isRowSelected={this.isParameterSelected}
            pageSize={pageSize}
            handleFilterChange={this.handleFilterChangeDebounced}
          />
        </div>
        {isEditActive && (
          <Dimmer active={true} page={true}>
            <div className="edit-view" style={{ flex: editSize , width : editSize == 0.3 ? "500px" : "1000px" }}>
              <EditParameter toggleModal={toggleModal} groupName="Escalator" columns={columns} />
            </div>
          </Dimmer>
        )}
      </div>
    );
  }
  /**
   * Returns status if parameter has been selected
   * @param {Api.AnyParameter} fault
   * @returns {boolean}
   */
  private isParameterSelected = (parameter: Api.AnyParameter): boolean => {
    const { editedObjectId } = this.props;
    if (editedObjectId && parameter.id === editedObjectId) {
      return true;
    } else {
      return false;
    }
  };
}

const mapStateToProps = (state: State.Root) => ({
  columns: state.columns,
  mainState: state.main,
  isEditActive: isEditActiveSelector(state.editView)
});

const mapDispatchToProps = (dispatch: Dispatch<EditActions | MainActions>) => ({
  editActions: bindActionCreators({ ...editActions }, dispatch),
  mainActions: bindActionCreators({ ...mainActions }, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(EscalatorParametersTable);
